import React from 'react';
import styleable from 'react-styleable';
import css from './index.scss';
import DownloadCertificatesForm from './pages/form';
import withLoader from '../with-loader/index';

const DownloadCertificates = (props) => {
    const view = (
        <div className={css.downloadCertificatesContainer}>
            <DownloadCertificatesForm {...props} />
        </div>);

    return view;
};

const styledCerts = styleable(css)(DownloadCertificates);

export default withLoader('loading')(styledCerts);



// WEBPACK FOOTER //
// ./app/components/download-certificates/index.js